import { convertTask, Task, TasksResponse } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useTask(
  taskId?: string,
  params?: {
    fromDate?: string
    toDate?: string
  },
  enabled = true
) {
  const { server } = useServer()

  return useQuery<Task>({
    queryKey: keys.detail(taskId, params?.fromDate, params?.toDate),
    queryFn: fetchTask,
    enabled: enabled && !!taskId,
    refetchOnMount: 'always',
  })

  async function fetchTask(): Promise<Task> {
    if (!taskId) {
      throw new Error('Task ID is required')
    }
    let url = `v2/tasks/custom/${taskId}`
    const queryParams = new URLSearchParams()
    if (params?.fromDate) {
      queryParams.append('from_date', params.fromDate)
    }
    if (params?.toDate) {
      queryParams.append('to_date', params.toDate)
    }
    const queryString = queryParams.toString()
    if (queryString) {
      url += `?${queryString}`
    }

    const response = await server.get<TasksResponse.Task>(url)
    return convertTask(response)
  }
}
